import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              Advanced FinOps Dashboard for <span className="highlight">AWS Cost Optimization</span>
            </h1>
            <p className="hero-description">
              Finoptic provides comprehensive financial operations management for your AWS infrastructure. 
              Our intelligent dashboard coupled with powerful automation plugins helps you optimize costs, 
              track spending, and implement best practices across your entire AWS environment.
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary">Start Free Trial</a>
              <a href="#demo" className="btn btn-secondary">Watch Demo</a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">30%</span>
                <span className="stat-label">Average Cost Reduction</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Automated Monitoring</span>
              </div>
              <div className="stat">
                <span className="stat-number">5min</span>
                <span className="stat-label">Setup Time</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="placeholder-screenshot">
              Dashboard Screenshot Placeholder
              <br />
              (1200x800px)
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;